<template>
  <span>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card class="card--flex-toolbar">
      <v-toolbar color="blue-grey lighten-5" class="elevation-0" tabs>
        <v-toolbar-title>
          <h5>{{nomefor}}</h5>
        </v-toolbar-title>
        <v-tabs
          v-model="active"
          show-arrows
          slot="extension"
          color="grey lighten-4"
          slider-color="black"
        >
          <v-tab key="1" ripple>Requisições</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="active" style="min-height:300px">
          <v-tab-item key="1">
            <v-form v-model="valid">
              <v-container fluid>
                <v-layout row wrap>
                  <!-- LINHA 1, CAMPO NOME DO DEPENDENTE -->
                  <v-flex xs12 sm4>
                    <v-select
                      :items="profissional"
                      filled
                      v-model="requisicao.fk_profissional"
                      item-text="nome"
                      item-value="id"
                      label="Motorista"
                      @input="onProfissionalSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-select
                      :items="veiculo"
                      filled
                      v-model="requisicao.fk_veiculo"
                      item-text="descricao"
                      item-value="id"
                      label="Veículo"
                      @input="onVeiculoSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-select
                      :items="transportadora"
                      filled
                      v-model="requisicao.fk_fornecedor"
                      item-text="nome"
                      item-value="id"
                      label="Fornecedor"
                      @input="onFornecedorSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="requisicao.id"
                      label="Código"
                      v-bind:disabled='true'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field
                      v-model="requisicao.data_lancto"
                      label="Data"
                      type="tel"
                      v-mask="'##/##/####'"
                      required
                      @input="onDataInicio()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-select
                      :items="tipolanctos"
                      v-model="itemrequisicao.descr"
                      item-text="descr"
                      label="Lançamento"
                      @input="onLanctoSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-select
                      :items="plano"
                      filled
                      v-model="requisicao.fk_plano"
                      item-text="descricao"
                      item-value="id"
                      label="Descrição"
                      @input="onPlanoSelect()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field v-model="requisicao.odometro" v-bind="currency_config" label="Odômetro"></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2 v-if="itemrequisicao.descr === 'Abastecimento'">
                    <v-currency-field
                      v-model="requisicao.litros"
                      label="Litros"
                      v-bind="currency_litro"
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2 v-if="itemrequisicao.descr === 'Abastecimento'">
                    <v-currency-field
                      v-model="requisicao.preco_litro"
                      v-bind="currency_litro"
                      label="Preço litro"
                      @input="onValorSelect()"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-currency-field
                      v-model="requisicao.valor_total"
                      label="Valor total"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <p id="paragrafo">
                      <span style="color: #FFFFFF;">{{valor_teste}}</span>
                    </p>
                  </v-flex>
                  <v-flex xs12 sm6 v-if="itemrequisicao.descr === 'Abastecimento'">
                    <v-switch
                      label="Completando tanque ?"
                      v-model="requisicao.tanque_cheio"
                      false-value="N"
                      true-value="S"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
        </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn small color="primary" @click="$router.push('/requisicoes')">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="onLanctoSaveClick()" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <div style="margin:50px"></div>
  </span>
</template>
<script>
import { showFlash, showError, validateDate, showConfirm, retPermissao } from '@/utils'
import planoService from '@/services/plano'
import requisicaoService from '@/services/requisicao'
// import fornecedorService from '@/services/fornecedor'
import profissionalService from '@/services/profissional'
import veiculosService from '@/services/veiculos'
import empresafornecedorService from '@/services/empresa_fornecedor'
import store from '@/store'
// import VueQrcode from 'vue-qrcode'
// import { QrcodeStream } from 'vue-qrcode-reader'
// import { QrcodeStream } from 'vue-qrcode-reader'
// import QrcodeStream from 'qrcode-stream'
// import { QrcodeStream } from '../../../src'

export default {
  name: 'requisicoes',
  data () {
    return {
      tipo: '',
      valor_teste: 0,
      baixado: '',
      seguro: 0,
      despesas: 0,
      receitas: 0,
      liquido: 0,
      total: 100,
      idviagem: 0,
      admin: false,
      requisicoes: [],
      transportadora: [],
      clientes: [],
      cliente: {},
      headers: [
        { text: 'Descrição', value: 'descricao', sortable: false },
        { text: 'Valor', value: 'valor_total', sortable: false }],
      item: {
        lanctto: ''
      },
      itemrequisicao: {
        descr: ''
      },
      tipolanctos: ['Abastecimento', 'Despesa', 'Serviço', 'Receita'],
      dependenteValid: true,
      dependentes: [],
      plano: [],
      profissional: [],
      veiculo: [],
      idveiculo: 0,
      nomefor: '',
      idprofissional: 0,
      idfornecedor: 0,
      idcliente: 0,
      dependente: {},
      currency_config: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 0,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      currency_litro: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: ' ',
        precision: 4,
        masked: false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER
      },
      viagem: {},
      requisicao: {},
      itemList: [],
      searchInput: '',
      loading: false,
      valid: true,
      active: 0,
      modo: '',
      menuDateNascimento: false,
      resultado: {},
      itemSenha: [
        'N',
        'S'
      ]
    }
  },
  mounted: async function () {
    try {
      let id = this.$route.params.id
      this.loading = true
      this.requisicao = {}
      this.requisicao.id = '0'
      this.profissional = []
      this.veiculo = []
      this.admin = false
      var data = new Date()
      var dia1 = data.getDate()
      var dia = dia1 < 10 ? '0' + dia1 : '' + dia1
      var mes1 = data.getMonth() + 1
      var mes = mes1 < 10 ? '0' + mes1 : '' + mes1
      var ano = data.getFullYear()
      var dtini = dia + '/' + mes + '/' + ano
      this.requisicao.data_lancto = dtini
      this.tipo = store.tipo
      // const result = await usuarioprofissionalService.getByUsuario()
      const result = await profissionalService.getAllWithoutPagination()
      if (result.data === undefined) {
        this.profissional = result.data
        showError('Não localizei profissionais!!!')
        return
      }
      // var result1 = await profissionalveiculosService.getAllZero()
      var result1 = await veiculosService.getByAll()
      if (result1.data === undefined) {
        this.veiculo = result1.data
        showError('Não localizei veículos!!!')
        return
      }
      // var result2 = await fornecedorService.getAllZero()
      // var result2 = await fornecedorService.getFor()
      var result2 = await empresafornecedorService.getByAll()
      this.transportadora = result2.data
      if (result.data[0].admin === 'S') {
        this.admin = true
      }
      if (result1.data.length > 1) {
        this.admin = true
      }
      this.profissional = result.data
      this.veiculo = result1.data
      this.getTipo()
      if (id === undefined) {
        this.modo = 'I'
        this.baixado = 'N'
        this.loading = false
        return
      }
      this.requisicao.tanque_cheio = 'N'
      this.modo = 'A'
      const resultl = await requisicaoService.getById(id)
      if (resultl.data[0] !== undefined) {
        this.requisicao = resultl.data[0]
        this.itemrequisicao.descr = resultl.data[0].tipo
        this.idfornecedor = this.requisicao.fk_fornecedor
        this.idprofissional = this.requisicao.fk_profissional
        this.idveiculo = this.requisicao.fk_veiculo
        this.baixado = this.requisicao.baixado
        this.onLanctoSelect()
      }
    } catch (error) {
      showError(error)
    } finally {
      this.loading = false
    }
  },
  computed: {
    isAlterar: function () {
      return this.modo === 'A'
    }
  },
  methods: {
    onLanctoNewClick () {
      this.requisicao.odometro = 0
      this.requisicao.litros = 0
      this.requisicao.valor_total = 0
      this.requisicao.preco_litro = 0
      this.plano = []
    },
    async deleteItem (item) {
      var ret = retPermissao('Requisições', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover requisição ?`, async result => {
          if (result) {
            try {
              // this.loading = true
              await requisicaoService.delete(item.id)
              this.getLanctos(this.idviagem)
            } catch (error) {
              showError(error)
            } finally {
              // this.loading = false
            }
          }
        })
      }
    },
    async editItem (item) {
      var ret = retPermissao('Requisições', 'alterar')
      if (ret === true) {
        this.lancto = item
      }
    },
    async onPlanoSelect () {
      var passo
      for (passo = 0; passo <= this.plano.length - 1; passo++) {
        if (this.plano[passo].id === this.requisicao.fk_plano) {
          this.requisicao.preco_litro = this.plano[passo].valor
        }
      }
    },
    async onClienteSelect () {
      this.idcliente = this.cliente.id
      this.idfornecedor = store.fk_fornecedor
      // var result3 = await requisicaoService.getByTodos(this.idcliente)
      var result3 = await requisicaoService.getByTodos(this.idcliente, store.fk_fornecedor)
      if (result3.data === undefined) {
        // this.veiculo = result1.data
        showError('Não localizei dados!!!')
        return
      }
      this.profissional = result3.data.motoristas
      this.veiculo = result3.data.veiculos
      this.transportadora = result3.data.clientes
    },
    async onFornecedorSelect () {
      this.idfornecedor = this.requisicao.fk_fornecedor
    },
    async onProfissionalSelect () {
      this.idprofissional = this.requisicao.fk_profissional
    },
    async onVeiculoSelect () {
      this.idveiculo = this.requisicao.fk_veiculo
    },
    async onValorSelect () {
      if (this.requisicao.litros !== undefined && this.requisicao.preco_litro !== undefined && this.requisicao.litros > 0 && this.requisicao.preco_litro > 0) {
        this.requisicao.valor_total = this.requisicao.preco_litro * this.requisicao.litros
        this.valor_teste = this.requisicao.preco_litro * this.requisicao.litros
      }
    },
    async getTipo () {
      this.tipolanctos = []
      try {
        const result = await planoService.getByTipo()
        if (result.data !== undefined) {
          var passo
          for (passo = 0; passo <= result.data.length - 1; passo++) {
            this.tipolanctos.push(result.data[passo].descricao)
          }
          this.itemrequisicao.descr = this.tipolanctos[0]
          this.onLanctoSelect()
        }
      } catch (error) {
        showError(error)
      } finally {
      }
    },
    async onLanctoSelect () {
      this.plano = []
      try {
        const result = await planoService.getByNome(this.itemrequisicao.descr, store.id_empresa)
        if (result.data !== undefined) {
          this.plano = result.data
        }
      } catch (error) {
        showError(error)
      } finally {
      }
    },
    async onLanctoSaveClick () {
      try {
        if (this.baixado !== 'N') {
          showError('Requisição não pode ser alterada!!!')
          return
        }
        if (this.idprofissional === 0) {
          showError('Não localizei profissional!!!')
          return
        }
        if (this.idveiculo === 0) {
          showError('Não localizei veículo!!!')
          return
        }
        if (this.idfornecedor === 0) {
          showError('Não localizei fornecedor!!!')
          return
        }
        this.requisicao['fk_veiculo'] = this.idveiculo
        this.requisicao['fk_profissional'] = this.idprofissional
        this.requisicao['fk_fornecedor'] = this.idfornecedor
        if (store.tipo !== 'USUARIO') {
          this.requisicao['fk_empresa'] = this.idcliente
        }
        if (this.modo === 'A') {
          await requisicaoService.savePut(this.requisicao)
        } else {
          await requisicaoService.save(this.requisicao)
        }
        this.requisicao.odometro = 0
        this.requisicao.litros = 0
        this.requisicao.valor_total = 0
        this.requisicao.preco_litro = 0
        this.plano = []
        showFlash('Salvo com sucesso')
      } catch (error) {
        showError(error)
      }
    },
    async onDataInicio () {
      try {
        if (this.requisicao.data_lancto.length === 10) {
          var ret = validateDate(this.requisicao.data_lancto)
          if (ret === false) {
            showError('Data inválida')
            this.requisicao.data_lancto = ''
          }
        }
      } catch (error) {
        showError(error)
      } finally {
        // this.ultimoLancamentoLoadingIsVisible = false
      }
    },
    onSelectOrigem (item) {
      this.viagem.fk_origem = item.codigo
    },
    onSelectDestino (item) {
      this.viagem.fk_destino = item.codigo
    }
  }
}
</script>
<style scoped>
#create-post video, #create-post canvas {
  width: 512px;
  max-width: 100%;
  display: none;
  margin: auto;
}
#create-post #pick-image {
  display: none;
}
#create-post #capture-btn {
  margin: 10px auto;
}
.mdl-spinner {
  margin: auto;
}

.main-image {
  max-width: 100%;
  margin: auto;
  display: block;
}
.flex{
    height: 60px;
}
</style>
